import styled from 'styled-components'

export const WrapperLetterCounter = styled.div`
  display: flex;
  flex-direction: row;
`

export const TextLetterCounter = styled.div`
  margin-left: auto;
  font-size: 9pt;
`
